export default __webpack_public_path__ + "static/elite-38322c0e637ebe9136cd1444e9e46cf9.png";